// extracted by mini-css-extract-plugin
export default {"card":"Card_card__cEIkO","content":"Card_content__36U+2","img":"Card_img__WzWw4","badge":"Card_badge__y1IHw"};